import { billingZones } from 'localizations';

import type { BillingZone } from '../config';

export const isBillingZone = (
  billingZone: unknown,
): billingZone is BillingZone =>
  typeof billingZone === 'string' && Object.hasOwn(billingZones, billingZone);
